import React from 'react';

// Days in order, starting from Monday
const WEEK_DAYS = [
  'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'
];

function getTodayIndex() {
  // JS: 0=Sunday, 1=Monday...
  const jsDay = new Date().getDay();
  return jsDay === 0 ? 6 : jsDay - 1;
}

function formatDay(day) {
  return day.charAt(0).toUpperCase() + day.slice(1,3);
}

function formatTime(time) {
  // "09:00" => "9:00 AM"
  if (!time) return '';
  let [h, m] = time.split(":");
  h = parseInt(h, 10);
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${h}:${m} ${ampm}`;
}

const BusinessHoursCard = ({ businessHours }) => {
  // Map days to ensure full week, fallback if any missing
  const hoursMap = Object.fromEntries(
    businessHours.map(d => [d.day.toLowerCase(), d])
  );
  const todayIdx = getTodayIndex();
  const todayDay = WEEK_DAYS[todayIdx];
  // Reorder: today first, then rest
  const orderedDays = [todayDay, ...WEEK_DAYS.filter(d => d !== todayDay)];

  return (
    <div className="business-hours-list-plain" style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '0.35rem', fontSize: '1.09rem' }}>
      <h3 style={{ margin: '0 0 0.7rem 0', fontWeight: 700 }}>Business Hours</h3>
      {orderedDays.map(dayKey => {
        const day = hoursMap[dayKey] || { day: dayKey, open: false };
        return (
          <div
            key={dayKey}
            className={`business-hours-row${dayKey === todayDay ? ' today' : ''}`}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 18, fontWeight: dayKey === todayDay ? 700 : 500, color: dayKey === todayDay ? 'var(--primary-700)' : undefined }}
          >
            <span className="business-hour-day" style={{ minWidth: 60 }}>{formatDay(day.day)}</span>
            {day.open ? (
              <span className="business-hours-time">
                {formatTime(day.openingTime)} - {formatTime(day.closingTime)}
              </span>
            ) : (
              <span className="business-hours-closed" style={{ color: dayKey === todayDay ? '#e11d48' : '#94a3b8' }}>Closed</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default BusinessHoursCard;
